import { render, staticRenderFns } from "./create-statement.vue?vue&type=template&id=5a7afc28&scoped=true"
import script from "./create-statement.vue?vue&type=script&lang=js"
export * from "./create-statement.vue?vue&type=script&lang=js"
import style0 from "./create-statement.vue?vue&type=style&index=0&id=5a7afc28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7afc28",
  null
  
)

export default component.exports